import { render, staticRenderFns } from "./selectSituacaoVendedor.vue?vue&type=template&id=c722140a&"
import script from "./selectSituacaoVendedor.vue?vue&type=script&lang=js&"
export * from "./selectSituacaoVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VFlex,VSelect})
